"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deviceLandscape = exports.device = exports.size = void 0;
const styled_components_1 = require("styled-components");
exports.size = {
    mobileS: 320,
    mobileM: 569,
    mobile: 599,
    tablet: 899,
    laptop: 1199,
};
const deviceMedia = {
    mobileS: `(max-width: ${exports.size.mobileS}px)`,
    mobileM: `(max-width: ${exports.size.mobileM}px)`,
    mobile: `(max-width: ${exports.size.mobile}px)`,
    tablet: `(max-width: ${exports.size.tablet}px)`,
    laptop: `(max-width: ${exports.size.laptop}px)`,
};
var OrientationType;
(function (OrientationType) {
    OrientationType["Unknown"] = "unknown";
    OrientationType["Portrait"] = "portrait";
    OrientationType["Landscape"] = "landscape";
})(OrientationType || (OrientationType = {}));
const constructCssMedia = (cssCode, media, orientation = OrientationType.Unknown) => {
    const mediaQuery = orientation !== OrientationType.Unknown
        ? `screen and ${media} and (orientation: ${orientation})`
        : `screen and ${media}`;
    return (0, styled_components_1.css) `
    @media ${mediaQuery} {
      ${cssCode}
    }
  `;
};
const constructCssMediaLandscape = (cssCode, media) => constructCssMedia(cssCode, media, OrientationType.Landscape);
exports.device = {
    mobileS: (cssCode) => constructCssMedia(cssCode, deviceMedia.mobileS),
    mobileM: (cssCode) => constructCssMedia(cssCode, deviceMedia.mobileM),
    mobile: (cssCode) => constructCssMedia(cssCode, deviceMedia.mobile),
    tablet: (cssCode) => constructCssMedia(cssCode, deviceMedia.tablet),
    laptop: (cssCode) => constructCssMedia(cssCode, deviceMedia.laptop),
};
exports.deviceLandscape = {
    mobileM: (cssCode) => constructCssMediaLandscape(cssCode, deviceMedia.mobileM),
    mobile: (cssCode) => constructCssMediaLandscape(cssCode, deviceMedia.mobile),
    tablet: (cssCode) => constructCssMediaLandscape(cssCode, deviceMedia.tablet),
};
